module.exports = __webpack_public_path__ + "f43a47b401f8875512681beee1ae1773.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/imgs/Industriearbeitsplätze.svg
// module id = 260
// module chunks = 1